export const skillsData = [
  "HTML",
  "CSS",
  "Javascript",
  "Flutter",
  "Angular",
  "NodeJS",
  "PHP",
  "Laravel",
  "Java",
  "Android",
  "MongoDB",
  "MySQL",
];
